import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
import {
  bindUnapprovedSessions,
  unbindUnapprovedSessions
} from "actions/paywallActions"
import UsersByDate from "./usersByDate"

class UnapprovedSessions extends Component {

  static propTypes = {
    bindUnapprovedSessions: PropTypes.func.isRequired,
    unbindUnapprovedSessions: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.boundUnapprovedSessionsRefs = {}
  }

  componentDidMount () {
    this.bindUnapprovedSessions(this.props)
  }

  componentWillUnmount () {
    this.unbindUnapprovedSessions()
  }

  bindUnapprovedSessions (props) {
    const { bindUnapprovedSessions: bind } = props;
    bind(this.boundUnapprovedSessionsRefs)
  }

  unbindUnapprovedSessions () {
    const { unbindUnapprovedSessions: unbind } = this.props;
    unbind(this.boundUnapprovedSessionsRefs)
  }

  render () {
    return (
      <UsersByDate sessionType="unapproved" />
    )
  }

}

export default connect(
  (/*state*/) => ({}),
  {
    bindUnapprovedSessions,
    unbindUnapprovedSessions
  }
)(UnapprovedSessions)



// WEBPACK FOOTER //
// ./src/views/staff/unapprovedSessions.jsx